import http from '@/utils/http';

export default {
    buscarAgricola(geometria) {
        return http.post({
            url: '/historico/agricola',
            lockScreen: true,
            data: { geometria },
            lockMessage: 'Buscando histórico agrícola'
        });
    },

    buscarHistoricoMonitoramentoPorAreaMonitoradaId(
        idAreaMonitorada,
        somenteAlertas = false
    ) {
        return http.get({
            url: `/historico/${idAreaMonitorada}?somenteAlertas=${somenteAlertas}`,
            lockScreen: true,
            lockMessage: 'Buscando histórico monitoramento'
        });
    }
};
